import { useEffect, useCallback } from 'react';
import { useMediaQuery } from '@mui/material';
import { colors } from '../../../options/colors';
import Chart from 'chart.js/auto';
import annotationPlugin from 'chartjs-plugin-annotation';
import NoResultsText from '../../Typography/NoResultsText/NoResultsText';

// Helpers
import generatePlaceholderArray from '../../../utils/helpers/generatePlaceholderArray';

// Register annotationPlugin to enable drawing annotation lines
Chart.register(annotationPlugin);

const PrintLineChart = ({ id, labels, data, handleClick, isDrillStats, selectedSession, selectedDataset }) =>
{
  // Dynamically display chart based on breakpoint
  const matches = true;
  const chartId = 'lineChart';
  const createChart = useCallback((datasets, isMobile, isDrills, selSession, datasetIdx) =>
  {
    // Get canvas by ID - allows rendering different chart for desktop and mobiles to set different font sizes

    const ctx = document.getElementById(chartId).getContext('2d');
    const sessionIdx = false;



    // Create data object for chart config - iterate through datasets and generate dataset for each record
    const sets = [];

    datasets.forEach((dataset, idx) =>
    {
      // Create an array with length of 10 and fill all values with dataset.color - enables updating bg colour on click
      // Set initial bar colour for first dataset to secondary orange for index stats bar chart
      if (!dataset)
      {
        return;
      }
      let theData = [...dataset.data];
      if (dataset.data[0] !== null)
      {
        dataset.data.unshift(null);
        labels.unshift('');
      }
      const backgroundColor = generatePlaceholderArray(10, dataset.color);
      if (idx === datasetIdx && !isDrills) backgroundColor[sessionIdx] = colors.secondaryOrange;
      sets.push({
        data: theData,
        borderColor: colors.primaryRed,
        borderWidth: 2,
        pointRadius: 5,
        backgroundColor: colors.white,
        borderRadius: 5,
        barPercentage: 0.8,
        categoryPercentage: 0.9,
      });


    });

    const data = {
      labels: isDrills ? labels : labels[datasetIdx],
      datasets: sets,
    };

    // Create chart config object
    const config = {
      type: 'line',
      data,
      options: {
        animation: {
          duration: 0
        },
        maintainAspectRatio: false,
        pointRadius: 10,
        indexAxis: isMobile ? 'y' : 'x',
        borderSkipped: 'false',
        plugins: {
          // Hide legend
          legend: {
            display: false,
          },
          // Hide hover tooltip
          tooltip: {
            enabled: false,
          },
          autocolors: false,
          // Draw annotation lines
          borderColor: colors.primaryRed,
          borderWidth: 5,
        },
        scales: {
          x: {

            position: 'top',
            borderColor: colors.primaryRed,
            borderWidth: 10,
            grid: {
              color: 'transparent',
              borderColor: colors.black,
              tickColor: colors.black,
            },
            ticks: {
              color: colors.black,
              font: {
                family: 'RobotoRegular, sans-serif',
                size: 15,

              },
            },
          },
          y: {
            position: 'left',
            beginAtZero: true,
            borderColor: colors.primaryRed,


            // Dynamic y scale for drill stats
            max: 3,
            grid: {
              color: colors.chartGridGrey,
              borderColor: isMobile ? colors.primaryGrey : 'transparent',
              tickColor: isMobile ? colors.primaryGrey : 'transparent',
            },
            ticks: {
              callback: function (value, index, ticks)
              {

                if (ticks.length - 1 === index)
                {
                  return value;
                }
                if (Math.floor(value) === value)
                {
                  return value;
                }
              },
              color: isMobile ? 'transparent' : colors.primaryGrey,
              padding: isMobile ? 5 : 10,
              font: {
                family: 'RobotoRegular, sans-serif',
                size: 13,
              },
            },
          },
        },
      },
      plugins: [!isDrills],
    };

    // Instantiate chart with config object
    new Chart(ctx, config);
  }, [labels, handleClick]);

  useEffect(() =>
  {
    if (data && data.length > 0)
    {
      // Remove existing canvas before re-drawing to resolve error when parent re-renders
      const canvas =
        '<canvas id="' + chartId + '"/>'
        ;
      const chart = document.getElementById(chartId);
      if (chart) chart.remove();
      const chartContainer = document.getElementById(`${id}ChartContainer`);
      chartContainer.innerHTML = canvas;
      createChart(data, !matches, isDrillStats, selectedSession, selectedDataset);
    }
  }, [id, createChart, data, matches, isDrillStats, selectedSession, selectedDataset]);

  return (
    <>
      {
        (!data || data.length === 0) &&
        <NoResultsText text={'No chart data'} />
      }
    </>
  );
};

export default PrintLineChart;
